// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteEntityItem_container__WJeOL {
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_top__u9M9T {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_bottom__56Qm0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_sub-bottom__zNDi4 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  gap: 8px;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_description__dlnuT {
  color: var(--text-1);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3 !important;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_description--wrapper__6Zb7o {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_avatar__o2Ahe {
  min-width: 80px;
  width: 80px;
  aspect-ratio: 1/1;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_avatar__o2Ahe img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_name__SDlS4 {
  color: var(--accent-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_name--wrapper__mQSU3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_info__-JYNN {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_position__a1emB {
  color: var(--accent-color-dark);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_inst-name__742xv {
  color: var(--grey-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_statistics__Sg6F6 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_statistics--item__svBGZ {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-1);
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_statistics__Sg6F6 svg {
  width: 10px;
  height: 10px;
}
.FavoriteEntityItem_container__WJeOL .FavoriteEntityItem_statistics__Sg6F6 svg path {
  stroke: var(--accent-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Navbar/Components/FavoriteItemNav/FavoriteEntityItem/FavoriteEntityItem.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAIE;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAFN;AAME;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AAJJ;AAKI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAHN;AAOE;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALJ;AAOI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AALN;AASE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AAPJ;AAUE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAWE;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AATJ;AAYE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVN;AAaI;EACE,WAAA;EACA,YAAA;AAXN;AAaM;EACE,kCAAA;AAXR","sourcesContent":[".container {\n  display: flex;\n  padding: 16px 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n\n  .top {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n  }\n\n  .bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    align-self: stretch;\n  }\n\n  .sub-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    align-self: stretch;\n    gap: 8px;\n  }\n\n  .description {\n    color: var(--text-1);\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3 !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis;\n\n    &--wrapper {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    }\n  }\n\n  .avatar {\n    min-width: 80px;\n    width: 80px;\n    aspect-ratio: 1/1;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .name {\n    color: var(--accent-color);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n\n    &--wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n    }\n  }\n\n  .info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    flex: 1 0 0;\n  }\n\n  .position {\n    color: var(--accent-color-dark);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .inst-name {\n    color: var(--grey-text);\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }\n\n  .statistics {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-self: stretch;\n\n    &--item {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      color: var(--text-1);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    svg {\n      width: 10px;\n      height: 10px;\n\n      path {\n        stroke: var(--accent-color-medium);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FavoriteEntityItem_container__WJeOL`,
	"top": `FavoriteEntityItem_top__u9M9T`,
	"bottom": `FavoriteEntityItem_bottom__56Qm0`,
	"sub-bottom": `FavoriteEntityItem_sub-bottom__zNDi4`,
	"description": `FavoriteEntityItem_description__dlnuT`,
	"description--wrapper": `FavoriteEntityItem_description--wrapper__6Zb7o`,
	"avatar": `FavoriteEntityItem_avatar__o2Ahe`,
	"name": `FavoriteEntityItem_name__SDlS4`,
	"name--wrapper": `FavoriteEntityItem_name--wrapper__mQSU3`,
	"info": `FavoriteEntityItem_info__-JYNN`,
	"position": `FavoriteEntityItem_position__a1emB`,
	"inst-name": `FavoriteEntityItem_inst-name__742xv`,
	"statistics": `FavoriteEntityItem_statistics__Sg6F6`,
	"statistics--item": `FavoriteEntityItem_statistics--item__svBGZ`
};
export default ___CSS_LOADER_EXPORT___;
